import { expenseConstants } from "../actions/constants/expenseConstants";

export const getExpenseReducer = (state = {}, action: any) => {
    switch (action.type) {
        case expenseConstants.getExpenseRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case expenseConstants.getExpenseSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                expensedata: action.payload
            }
        case expenseConstants.getExpenseFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const getExpenseParamsReducer = (state = {}, action: any) => {
    switch (action.type) {
        case expenseConstants.getExpenseParamsRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case expenseConstants.getExpenseParamsSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                expensedata: action.payload
            }
        case expenseConstants.getExpenseParamsFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const createExpenseReducer = (state = {}, action: any) => {
    switch (action.type) {
        case expenseConstants.createExpenseRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case expenseConstants.createExpenseSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                expensedata: action.payload
            }
        case expenseConstants.createExpenseFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        case expenseConstants.createExpenseReset:
            return {
                isLoading: false,
                isSuccess: false,
                isError: false
            }
        default:
            return state;
    }
}

export const deleteExpenseReducer = (state = {}, action: any) => {
    switch (action.type) {
        case expenseConstants.deleteExpenseRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case expenseConstants.deleteExpenseSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                expensedelete: action.payload
            }
        case expenseConstants.deleteExpenseFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        case expenseConstants.deleteExpenseReset:
            return {
                isLoading: false,
                isSuccess: false,
                isError: false
            }
        default:
            return state;
    }
}

export const getExpenseViewReducer = (state = {}, action: any) => {
    switch (action.type) {
        case expenseConstants.expenseViewRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case expenseConstants.expenseViewSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                expenseview: action.payload
            }
        case expenseConstants.expenseViewFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}
